export default __webpack_public_path__ + "static/media/360-Factory-Visibility.4d69f018.pdf";